<template>
  <div>
    <vs-button :type="buttonType" :class="buttonClass" :color="buttonColor" @click.stop="fundsBtnAction()">{{ buttonText }}</vs-button>
    <!-- Popup para ver datos para abonar fondos -->
    <vs-popup :active.sync="popUpPayFunds" title="Abona a tu cuenta" class="header-primary">
      <stp-account-info-minimal class="p-5" :stpClabe="stpClabe" />
    </vs-popup>
  </div>
</template>

<script>
import StpAccountInfoMinimal from "@components/stp/StpAccountInfoMinimal";
import investorInfoHelper from "@/helpers/investorInfoHelper";

export default {
  components: {
    StpAccountInfoMinimal
  },
  mixins: [investorInfoHelper],
  name: 'PayFundsBtn',
  props: {
    buttonText: {
      type: String,
      default: "Abonar",
    },
    buttonEffect: {
      type: Boolean,
      default: false
    },
    buttonType: {
      type: String,
      default: "filled"
    },
    buttonColor: {
      type: String,
      default: "success"
    },
  },
  data() {
    return {
      popUpPayFunds: false,
      stpClabe: null,
      contractLevelData: null,
    }
  },
  computed: {
    buttonClass() {
      return this.buttonEffect ? "pulse-success" : "";
    },
    contractLevel() {
      return this.contractLevelData.contract_level;
    },
  },
  methods: {
    async fundsBtnAction() {
      await this.getInvestorContractLevelData(this.InvestorId);
      if (this.contractLevel < 3) {
        this.goToFunds();
        return;
      }
      let isForeign = this.userIsForeign(this.UserPersonType);
      if (!isForeign) {
        this.popUpPayFunds = true;
      } else {
        this.goToFunds();
      }
    },
    async getInvestorContractLevelData() {
      try {
        let res = await axios.get('/api/v2/investor/' + this.InvestorId + '/getContractLevelData');
        this.contractLevelData = res.data;
      } catch (error) {
      }
    },
    async goToFunds() {
      await this.$router.push({ name: 'abonarFondos' });
    },
  }
}
</script>
